import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Actions from "../Redux/action";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { toast } from "react-toastify";
import { roomData } from "../Redux/reducer/GetRoomDataReducer";
import moment from "moment";
import nodatafound from '../asset/img/datanotfound_black.png';
import { getStudentReports } from "../Redux/reducer/StudentReportReducer";
import AppDatePicker from "../component/AppDatePicker";
import TimePicker from "rc-time-picker";
import 'rc-time-picker/assets/index.css';
import AppLoader from "../component/AppLoader";
import {useLocation , useNavigate } from "react-router-dom";
import { getCollegeList, getCourseList, getSlotList, getYearList, getdepartmentList, getdepartmentSearch } from "../Redux/reducer/SchedulerReducer";
import { getHostelListSelectSelector } from "../Redux/reducer/HostelReducer";

export const StudentAttendance = () => {
    const EXCEL_EXTENSION = '.xlsx'
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const dispatch = useDispatch();
    const courseList = useSelector(getCourseList)
    const hostelList = useSelector(getHostelListSelectSelector)
    const collegeList = useSelector(getCollegeList)
    const slotList = useSelector(getSlotList)
    const yearList = useSelector(getYearList)
    const departmentList = useSelector(getdepartmentList)
    const sectionList = useSelector(getdepartmentSearch);
    const [room, setRoom] = useState('')
    const [status, setStatus] = useState('')
    const roomList = useSelector(roomData)
    const reportList = useSelector(getStudentReports)
    const navigate = useNavigate();
    const location = useLocation();
    const defaultTimeState = {
        start_time: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
        end_time: moment()
    };
    const normalizeStateFromLocation = (state) => {
        if (!state) return { fromDate: '', toDate: '', formDetails: { ...defaultTimeState }, viewReports: false, isLoading: false };
        const fromDate = state.fromDate ? (moment(state.fromDate).isValid() ? moment(state.fromDate) : '') : '';
        const toDate = state.toDate ? (moment(state.toDate).isValid() ? moment(state.toDate) : '') : '';
        const fd = state.formDetails || {};
        const startTime = fd.start_time != null && fd.start_time !== ''
            ? (moment.isMoment(fd.start_time) ? fd.start_time : moment(fd.start_time, ['HH:mm:ss', 'HH:mm']))
            : defaultTimeState.start_time;
        const endTime = fd.end_time != null && fd.end_time !== ''
            ? (moment.isMoment(fd.end_time) ? fd.end_time : moment(fd.end_time, ['HH:mm:ss', 'HH:mm']))
            : defaultTimeState.end_time;
        const formDetails = {
            ...defaultTimeState,
            ...fd,
            start_time: startTime.isValid() ? startTime : defaultTimeState.start_time,
            end_time: endTime.isValid() ? endTime : defaultTimeState.end_time,
        };
        return {
            fromDate: fromDate || '',
            toDate: toDate || '',
            formDetails,
            viewReports: !!state.viewReports,
            isLoading: !!state.isLoading,
        };
    };
    const initialState = normalizeStateFromLocation(location.state);
    const [fromDate, setFromDate] = useState(initialState.fromDate);
    const [formDetails, setFormDetails] = useState(initialState.formDetails);
    const [toDate, setToDate] = useState(initialState.toDate);
    const [err, setErr] = useState({});
    const [viewReports, setViewReport] = useState(initialState.viewReports);
    const [isLoading, setLoading] = useState(initialState.isLoading);

    useEffect(() => {
        if (location.state != null && typeof location.state === 'object') {
            const normalized = normalizeStateFromLocation(location.state);
            setFromDate(normalized.fromDate);
            setFormDetails(normalized.formDetails);
            setToDate(normalized.toDate);
            setViewReport(normalized.viewReports);
        }
    }, [location.state]);

    useEffect(() => {
        dispatch(Actions.clearReports())
        // dispatch(Actions.clearRooms())

        const callback = () => {
            setLoading(false)
        }
        setLoading(true)
        dispatch(Actions.roomAction("", callback))
        dispatch(Actions.CollegeListAction())
    }, [dispatch])

    const getHostelList = useCallback(() => {
        // let params = {
        //     page: pageNumber
        // }
        dispatch(Actions.hostelListSelect(""))
    }, [dispatch])

    useEffect(() => {
        getHostelList()
    }, [])


    const memberFilterList = (hostel_id) => {
        const callback = (response) => {
            dispatch(Actions.onboardingSearchAction(response));
        };
        let params = {
            hostel_id: hostel_id
        };
        dispatch(Actions.hostellerList(params, callback));
    };

    useEffect(() => {
        if (formDetails?.hostel_id) {
            memberFilterList(formDetails?.hostel_id);
        }
    }, [formDetails?.hostel_id]);

    // useEffect(() => {
    //     const params = {
    //         id: formDetails?.college_id
    //     }
    //     dispatch(Actions.CoursetAction(params))
    // }, [dispatch, formDetails?.college_id])

    // useEffect(() => {
    //     const params = {
    //         id: formDetails?.course_id
    //     }
    //     dispatch(Actions.YearAction(params))
    // }, [dispatch, formDetails?.course_id])

    // useEffect(() => {
    //     const params = {
    //         id: formDetails?.course_id
    //     }
    //     dispatch(Actions.DepartmentAction(params))
    // }, [dispatch, formDetails?.course_id])

    // const getHostelList = useCallback(() => {
    //     setLoading(true)
    //     const callback = (res) => {
    //         setLoading(false)
    //     }
    //     dispatch(Actions.hostelListSelect("", callback))
    // }, [])

    // useEffect(() => {
    //     getHostelList()
    // }, [])

    const clearReport = () => {
        setFromDate("")
        setRoom("")
        setErr("")
        setViewReport("")
        dispatch(Actions.clearReports())
        setFormDetails({ hostel_id: "", member_id: "", ...defaultTimeState })
        // dispatch(Actions.clearRooms())

    }

    const navigateToStudentWiseReport = (response) => {
        const hostelName = hostelList?.find((h) => h?.id == formDetails?.hostel_id)?.name || "Hostel";
        const stateFromDate = fromDate && (moment.isMoment(fromDate) ? fromDate.format("YYYY-MM-DD") : String(fromDate));
        const stateToDate = toDate && (moment.isMoment(toDate) ? toDate.format("YYYY-MM-DD") : String(toDate));
        const stateFormDetails = formDetails && {
            hostel_id: formDetails.hostel_id,
            member_id: formDetails.member_id,
            entry_type: formDetails.entry_type,
            subject_type: formDetails.subject_type,
            access_type: formDetails.access_type,
            start_time: formDetails.start_time && (moment.isMoment(formDetails.start_time) ? formDetails.start_time.format("HH:mm:ss") : String(formDetails.start_time)),
            end_time: formDetails.end_time && (moment.isMoment(formDetails.end_time) ? formDetails.end_time.format("HH:mm:ss") : String(formDetails.end_time)),
        };
        let stateResponse;
        try {
            stateResponse = JSON.parse(JSON.stringify(response || {}));
        } catch (_) {
            stateResponse = {
                response: Array.isArray(response?.response) ? response.response : [],
                absentees: Array.isArray(response?.absentees) ? response.absentees : [],
                total_present: response?.total_present,
                total_absentees: response?.total_absentees,
            };
        }
        navigate(`/studentdaywisereport`, {
            state: {
                fromDate: stateFromDate,
                toDate: stateToDate,
                formDetails: stateFormDetails,
                hostelName,
                response: stateResponse,
            }
        });
    };
    const viewReport = () => {
        if (!formDetails?.hostel_id) {
            setErr({ "hostel_id": "Please select the hostel" })
        } else if (!fromDate) {
            setErr({ "fromDate": "Please select the Date" })
        }
        // else if (!formDetails?.start_time) {
        //     setErr({ "hostel_id": "Please select the start_time" })
        // } else if (!formDetails?.end_time) {
        //     setErr({ "hostel_id": "Please select the end_time" })
        // } 
        else {
            const callback = (response) => {
                if (response?.status_code === 0) {
                    if (response?.response?.length > 0) {
                        navigateToStudentWiseReport(response)
                        setViewReport(true)
                    } else {
                        toast.error("No report found")
                    }
                    setLoading(false)
                    setErr("")
                }
                else {
                    toast.error(response?.message)
                    setLoading(false)
                }
            }
            const st_time = safeFormatDate(fromDate, 'YYYY-MM-DD', moment().format('YYYY-MM-DD'));
            const params = {
                date: st_time,
                hostel_id: formDetails?.hostel_id,
                start_time: safeFormatDate(formDetails?.start_time, 'HH:mm:ss', '00:00:00'),
                end_time: safeFormatDate(formDetails?.end_time, 'HH:mm:ss', '23:59:59'),
                access_type: formDetails?.access_type,
            }
            if (formDetails?.member_id) {
                params.member_id = formDetails?.member_id
            }
            setLoading(true)
            dispatch(Actions.studentReportAction(params, callback))
        }
    }

    const handleDownload = () => {
        const saveAsExcelFile = (buffer, fileName) => {
            const data = new Blob([buffer], { type: EXCEL_TYPE }) || [];
            FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION)
        }
        const callback = (response) => {
            if (response?.status_code === 0) {
                const reportData = response?.response || [];
                const hostelName = hostelList?.find((h) => h?.id == formDetails?.hostel_id)?.name || 'Hostel';
                const columnMap = [
                    { key: 'name', header: 'Name' },
                    { key: 'member_id', header: 'Member ID' },
                    { key: 'date', header: 'Date' },
                    { key: 'time', header: 'Time' },
                    { key: 'entry', header: 'Entry' },
                    { key: 'college', header: 'College' },
                    { key: 'hostel', header: 'Hostel' },
                    { key: 'room', header: 'Room' },
                    { key: 'attendance_type', header: 'Attendance Type' },
                ];
                const headers = reportData?.length ? columnMap.map((c) => c.header) : [];
                const aoa = [
                    [hostelName],
                    headers,
                    ...reportData.map((row) => columnMap.map((c) => row[c.key] ?? ''))
                ];
                const worksheet = XLSX.utils.aoa_to_sheet(aoa);
                if (headers.length > 1) {
                    worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
                }
                const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                saveAsExcelFile(excelBuffer, 'Report')
                toast.success("Downloaded Successfully")
                setLoading(false)

            }
            else {
                toast.error("Something went worng")
                setLoading(false)
            }
        }
        const st_time = safeFormatDate(fromDate, 'YYYY-MM-DD', moment().format('YYYY-MM-DD'));
        const params = {
            date: st_time,
            hostel_id: formDetails?.hostel_id,
            start_time: safeFormatDate(formDetails?.start_time, 'HH:mm:ss', '00:00:00'),
            end_time: safeFormatDate(formDetails?.end_time, 'HH:mm:ss', '23:59:59'),
            access_type: formDetails?.access_type,
        };
        if (formDetails?.member_id) {
            params.member_id = formDetails?.member_id
        }
        if (fromDate !== '') {
            setLoading(true)
            dispatch(Actions.studentReportAction(params, callback))
        }
    }
    const safeFormatDate = (val, formatStr, fallback = '') => {
        if (val == null || val === '') return fallback;
        const m = moment.isMoment(val) ? val : moment(val, ['HH:mm:ss', 'HH:mm', 'YYYY-MM-DD']);
        return m.isValid() ? m.format(formatStr) : fallback;
    };
    const getTimePickerValue = (val) => {
        if (val == null || val === '') return moment();
        if (moment.isMoment(val) && val.isValid()) return val;
        const m = moment(val, ['HH:mm:ss', 'HH:mm']);
        return m.isValid() ? m : moment();
    };
    const getDefaultTimesForDate = (date) => {
        if (!date) return defaultTimeState;
        const isToday = moment(date).isSame(moment(), 'day');
        return {
            start_time: moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
            end_time: isToday ? moment() : moment(date).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }),
        };
    };
    const handleDateSelect = (selected) => {
        setFromDate(selected);
        setFormDetails((prev) => ({ ...prev, ...getDefaultTimesForDate(selected) }));
        setViewReport(false);
        setErr("");
    };

    const handleHostelSelect = (selected) => {
        setViewReport(false)
        setFormDetails({ ...formDetails, 'hostel_id': parseInt(selected) })
        setErr({ ...err, "hostel_id": "" })
        memberFilterList(parseInt(selected));
    };

    const handleTimeChange = (value, time) => {
        if (value) {
            if (time === "start_time") {
                setFormDetails({ ...formDetails, [time]: value })
            } else {
                setFormDetails({ ...formDetails, [time]: value })
            }
        }
    }

    const disabledEndMinutes = (selectedHour) => {
        const startM = formDetails?.start_time != null ? (moment.isMoment(formDetails.start_time) ? formDetails.start_time : moment(formDetails.start_time, ['HH:mm:ss', 'HH:mm'])) : null;
        const startMinute = startM && startM.isValid() ? startM.minute() : 0;
        const startHour = startM && startM.isValid() ? startM.hour() : 0;
        if (selectedHour === startHour) {
            let minutes = [];
            for (let i = 0; i < startMinute; i++) {
                minutes.push(i);
            }
            return minutes;
        }
        return [];
    }

    const handleAccessTypeSelect = (selected) => {
        setViewReport(false)
        setFormDetails({ ...formDetails, 'access_type': parseInt(selected) })
        setErr({ ...err, "access_type": "" })
    };

    const disabledEndHours = () => {
        const startM = formDetails?.start_time != null ? (moment.isMoment(formDetails.start_time) ? formDetails.start_time : moment(formDetails.start_time, ['HH:mm:ss', 'HH:mm'])) : null;
        const startHour = startM && startM.isValid() ? startM.hour() : 0;
        let hours = [];
        for (let i = 0; i < startHour; i++) {
            hours.push(i);
        }
        return hours;
    }

    return (
        <>
            {
                isLoading && <AppLoader />
            }
            <div className="ecommerce-widget">
                <h5 className="card-header">Student Report</h5>
                <div className="card border-3 border-top border-top-primary">
                    <div className="row m-0">
                        <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label htmlFor="exampleInputEmail1" className="form-label">Hostel <span className="text-danger">*</span></label>
                            <select value={formDetails?.hostel_id} onChange={(e) => handleHostelSelect(e?.target?.value)}
                                className="form-select">
                                <option value='' hidden>Select Hostel</option>
                                {Array.isArray(hostelList) && hostelList?.map((o) => {
                                    return <option value={o?.id}>{o?.name}</option>
                                })
                                }
                            </select>
                            <p style={{ 'color': 'red' }}>{err?.hostel_id}</p>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label className="dateLabel">Date <span className="text-danger">*</span></label>
                            <div className="input-group mb">
                                <AppDatePicker
                                    disabled={!formDetails?.hostel_id}
                                    selected={fromDate && moment(fromDate).isValid() ? moment(fromDate).toDate() : null}
                                    placeholder="Date"
                                    maxDate={new Date()}
                                    onChange={(date) => {
                                        handleDateSelect(date)
                                    }}
                                    notValidTime={true}
                                    id='FormDatePicker'
                                />
                            </div>
                            <p style={{ 'color': 'red' }}>{err?.fromDate}</p>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label className="dateLabel">Time</label>
                            <div className="input-group w-75">
                                <TimePicker showSecond={false} format={'HH:mm'} disabled={!fromDate} clearIcon={false} onChange={(v) => handleTimeChange(v, "end_time")} value={getTimePickerValue(formDetails?.end_time)} disableClock={true} className="form-control dateInput cursor-pointer" disabledHours={disabledEndHours}
                                    disabledMinutes={disabledEndMinutes} />
                            </div>
                            {/* <p style={{ 'color': 'red' }}>{err?.end_time}</p> */}
                        </div>
{/* 
                        <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label htmlFor="exampleInputEmail1" className="form-label">Access Type </label>
                            <select value={formDetails?.access_type} onChange={(e) => handleAccessTypeSelect(e?.target?.value)}
                                className="form-select">
                                <option value='' hidden>Select Type</option>
                                <option value={"0"}>Vision</option>
                                <option value={"1"}>QR</option>
                            </select>
                            <p style={{ 'color': 'red' }}>{err?.acess_type}</p>
                        </div> */}


                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12 selectDate1">
                            {!viewReports ? <button type="button" className="btn btn-primary" onClick={() => viewReport()}>View</button>
                                : <button type="button"
                                    className="btn btn-primary" onClick={() => handleDownload()}>Download</button>}
                            &nbsp;
                            {(fromDate || reportList?.length > 0) && <button className="btn btn-primary" onClick={() => clearReport()}>Clear</button>}
                        </div>
                    </div>

                </div>
                {viewReports && <div className="card">
                    <div className="card-body p-0">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="table-responsive">
                                    {/* {
                                        (Array.isArray(reportList)) && <h4 className="mt-2 p-2">Presents-{Presentees?.length}</h4>
                                    } */}
                                    {(Array.isArray(reportList) && reportList?.length > 0) &&
                                        <table className="table onboardTable">
                                            <thead className="bg-light">
                                                <tr className="border-0">
                                                    <th className="border-0">S.No</th>
                                                    <th className="border-0">Total Student In </th>
                                                    <th className="border-0">Total Student Out</th>
                                                    <th className="border-0">Via Vision</th>
                                                    <th className="border-0">Via QR</th>
                                                    {/* <th className="border-0">Remarks</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(Array.isArray(reportList) && reportList?.length > 0) && reportList?.map((item, index) => {
                                                    return <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{item?.total_student_in}</td>
                                                        <td>{item?.total_student_out}</td>
                                                        <td>{item?.total_via_vision}</td>
                                                        <td>{item?.total_via_qr}</td>
                                                    </tr>
                                                })}

                                            </tbody>
                                        </table>}
                                    {reportList?.length === 0 && <div className="d-flex justify-content-center mt-5">
                                        <div className="NodataFound mb-3">
                                            <h3>No Data Found</h3>
                                        </div>
                                        <div className="NodataImage">
                                            <img src={nodatafound} alt="No Data Found" className="NoData" />
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
        </>
    )
}